import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductionJob } from '../../../models/review/production-job.model';
import { BulkDocAddPayload } from '../../../models/review/bulk-doc-add-payload.model';

@Component({
    selector: 'lex-production-job-dialog',
    templateUrl: './production-job-dialog.component.html',
    styleUrls: ['./production-job-dialog.component.scss'],
    standalone: false
})
export class ProductionJobDialogComponent {

  productionJob: ProductionJob;
  selectedCount: number;
  emailFamilyCount: number;
  expandEmailFamily: boolean = true;

  constructor(private dialogRef: MatDialogRef<ProductionJobDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.productionJob = data.productionJob;
    this.selectedCount = data.selectedCount;
    this.emailFamilyCount = data.emailFamilyCount;
  }

  ok() {
    const addDocsRequest = new BulkDocAddPayload();
    addDocsRequest.expandEmailFamily = this.expandEmailFamily;
    this.dialogRef.close(addDocsRequest);
  }
}
